// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"079b2738","147":"7e32902c","231":"311494d0","496":"cbf995ae","574":"4ef8987a","576":"29ba24ca","780":"f7e476d8"}[chunkId] + ".chunk.js";
};